import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  common: {
    borderRadius: 8,
    padding: 16,
    height: 52,
    flexDirection: 'row',
    alignItems: 'center',
  },
  commonLabel: {
    overflow: 'visible',
    fontFamily: 'InterSemiBold',
    includeFontPadding: false,
    fontSize: 16,
    lineHeight: 18,
  },

  primary: {
    color: colors.white,
    backgroundColor: colors.newUI.therapist.primaryBlue80,
  },
  primaryPressed: {
    backgroundColor: colors.newUI.therapist.primaryBlue50,
  },
  primaryHovered: {
    backgroundColor: colors.newUI.therapist.primaryBlue60,
  },
  primaryDisabled: {
    backgroundColor: colors.newUI.therapist.grey50,
    color: colors.white,
  },
  primaryLabel: {
    color: colors.white,
  },
  primaryLabelDisabled: {
    backgroundColor: colors.newUI.therapist.grey50,
    color: colors.white,
  },
  primaryLabelHovered: {},
  primaryLabelPressed: {},

  secondary: {
    color: colors.newUI.therapist.primaryBlue80,
    backgroundColor: colors.white,
    borderColor: colors.newUI.therapist.primaryBlue80,
    borderWidth: 1,
    borderStyle: 'solid',
  },
  secondaryPressed: {
    backgroundColor: colors.newUI.therapist.primaryBlue10,
  },
  secondaryHovered: {
    borderColor: colors.newUI.therapist.primaryBlue60,
  },
  secondaryDisabled: {
    borderColor: colors.newUI.therapist.grey50,
    color: colors.newUI.therapist.grey50,
    backgroundColor: colors.white,
    borderWidth: 1,
    borderStyle: 'solid',
  },
  secondaryLabel: {
    color: colors.newUI.therapist.primaryBlue80,
  },
  secondaryLabelDisabled: {
    color: colors.newUI.therapist.grey50,
  },
  secondaryLabelHovered: {
    color: colors.newUI.therapist.primaryBlue60,
  },
  secondaryLabelPressed: {
    color: colors.newUI.therapist.primaryBlue60,
  },

  tertiary: {
    color: colors.newUI.therapist.primaryBlue80,
    backgroundColor: 'transparent',
  },
  tertiaryPressed: {
    backgroundColor: colors.newUI.therapist.primaryBlue10,
    color: colors.newUI.therapist.primaryBlue80,
  },
  tertiaryHovered: {
    backgroundColor: colors.newUI.therapist.primaryBlue10,
  },
  tertiaryDisabled: {
    color: colors.newUI.therapist.grey50,
  },
  tertiaryLabel: {
    color: colors.newUI.therapist.primaryBlue80,
  },
  tertiaryLabelDisabled: {
    color: colors.newUI.therapist.grey50,
  },
  tertiaryLabelHovered: {
    color: colors.newUI.therapist.primaryBlue60,
  },
  tertiaryLabelPressed: {
    color: colors.newUI.therapist.primaryBlue80,
  },

  warning: {
    backgroundColor: colors.newUI.therapist.orange90,
  },
  warningPressed: { backgroundColor: colors.newUI.therapist.orange40 },
  warningHovered: {},
  warningDisabled: {},
  warningLabel: { color: colors.white },
  warningLabelDisabled: {},
  warningLabelHovered: {},
  warningLabelPressed: {},

  warningTertiary: {},
  warningTertiaryPressed: { backgroundColor: colors.newUI.therapist.orange40 },
  warningTertiaryHovered: {},
  warningTertiaryDisabled: {},
  warningTertiaryLabel: { color: colors.newUI.therapist.orange90 },
  warningTertiaryLabelDisabled: {},
  warningTertiaryLabelHovered: {},
  warningTertiaryLabelPressed: {},

  danger: {
    color: colors.white,
    backgroundColor: colors.newUI.therapist.red70,
  },
  dangerPressed: {
    backgroundColor: colors.newUI.therapist.red30,
  },
  dangerHovered: {
    backgroundColor: colors.newUI.therapist.red50,
  },
  dangerDisabled: {
    backgroundColor: colors.newUI.therapist.red30,
  },
  dangerLabel: {
    color: colors.white,
  },
  dangerLabelDisabled: {
    color: colors.white,
  },
  dangerLabelHovered: {},
  dangerLabelPressed: {},

  ghost: {
    color: colors.newUI.therapist.primaryBlue80,
    backgroundColor: colors.newUI.therapist.grey20,
  },
  ghostPressed: {
    backgroundColor: colors.newUI.therapist.primaryBlue10,
  },
  ghostHovered: {
    backgroundColor: colors.newUI.therapist.primaryBlue10,
  },
  ghostDisabled: {
    backgroundColor: colors.newUI.therapist.grey20,
    color: colors.newUI.therapist.grey50,
  },
  ghostLabel: {
    color: colors.newUI.therapist.primaryBlue80,
  },
  ghostLabelDisabled: {
    color: colors.newUI.therapist.grey50,
  },
  ghostLabelHovered: {
    color: colors.newUI.therapist.primaryBlue60,
  },
  ghostLabelPressed: {
    color: colors.newUI.therapist.primaryBlue80,
  },
});

export default styles;
